import React, { useRef, useState } from "react";
import { RoomUnit } from "../../CreateUnit_Form/room_unit";
import { RidePlans } from "../../../components/CreateUnit_Form/ride";
import styled from "styled-components/macro";
import { device } from "../../device";

const TuluUnitDrawExpended = ({
  rideItems,
  itemsCount,
  columns,
  isPDF,
  isCarpenter,
  colorUnit,
  logoImage,
  location,
  isSticker,
  isWires,
  isElectric,
}) => {
  const isCM = location !== "us";
  const roomUnitRef = useRef();
  const [roomUnitScale, setRoomUnitScale] = useState();
  const [rideUnitScale] = useState();

  const pdfFontSize = { fontSize: isPDF && 25 };
  const sideDetailsPdfWidth = { width: isPDF && 298 };
  const pdfLine = { width: isPDF && "100%" };
  const descWidth = { width: isPDF && 224 };
  return (
    <Wrapper>
      {!isPDF && !isCarpenter && (
        <TextWrapper>
          <P>All dimension are {isCM ? "In CM" : "In inches"}</P>
        </TextWrapper>
      )}

      <UnitWrapper
        style={{
          gridTemplateColumns: isPDF && "370px 750px",
          marginTop: isPDF && 70,
          marginLeft: isCarpenter && 65,
        }}
      >
        {!isCarpenter && (
          <SideDetails style={sideDetailsPdfWidth}>
            <UpperLine style={pdfLine} />
            <Title style={pdfFontSize}>TULU Unit</Title>
            <Flex>
              {" "}
              <Text style={{ ...pdfFontSize, ...descWidth }}>
                No. of columns
              </Text>{" "}
              <Spec style={pdfFontSize}>{columns.length}</Spec>{" "}
            </Flex>

            <Flex>
              <Text style={{ ...pdfFontSize, ...descWidth }}>Total Width</Text>{" "}
              <Spec style={pdfFontSize}>
                {" "}
                {isCM
                  ? columns.length * 50 + (columns.length - 1) * 1.5 + "CM"
                  : columns.length * 20 + (columns.length - 1) * 0.5 + `"`}
              </Spec>
            </Flex>
            <BottomLine style={pdfLine} />
          </SideDetails>
        )}

        <UnitWrapperRoom isPDF={isPDF} ref={roomUnitRef}>
          <RoomUnit
            setUnitScale={setRoomUnitScale}
            unitScale={roomUnitScale}
            itemsCount={itemsCount}
            columns={columns}
            colorUnit={colorUnit}
            isDraw
            isSticker={isSticker}
            location={location}
            isPDF={isPDF}
            logoImage={logoImage}
            isCarpenter={isCarpenter}
            isWires={isWires}
            isElectric={isElectric}
          />
        </UnitWrapperRoom>
      </UnitWrapper>
      {rideItems && !isPDF && !isCarpenter && (
        <RideWrapper unitScale={rideUnitScale}>
          <RidePlans
            type="scooter"
            //setUnitScale={setRideUnitScale}
            rideItems={rideItems?.filter((item) => item.type === "scooter")}
            location={location}
          />

          <RidePlans
            type="bicycle"
            //setUnitScale={setRideUnitScale}
            rideItems={rideItems?.filter((item) => item.type === "bicycle")}
            location={location}
          />

          <RidesEndDevider />
        </RideWrapper>
      )}
    </Wrapper>
  );
};

export { TuluUnitDrawExpended };

const Wrapper = styled.div`
  position: relative;
  @media ${device.mobileS} {
    margin-left: 39px;
  }
  @media ${device.tablet} {
    margin-left: 100px;
  }
`;

const UnitWrapper = styled.div`
  display: grid;
  @media ${device.mobileS} {
    grid-template-columns: 120px 200px;
    margin-top: 50px;
  }
  @media ${device.tablet} {
    grid-template-columns: 290px 750px;
    margin-top: 90px;
  }
`;

const RideWrapper = styled.div`
  /* transform: scale(1); */
`;

const UnitWrapperRoom = styled.div`
  width: 100%;
  @media ${device.mobileS} {
    transform: scale(0.13);
    transform-origin: left top;
    margin: 0px 0px -1000px 58px;
  }
  @media ${device.tablet} {
    transform: scale(0.55);
    transform-origin: left top;
    padding-top: 4px;
    margin: 0px 0px -300px 60px;
  }

  @media ${device.laptopL} {
    transform: scale(0.8);
    margin: 0px 0px -300px 98px;
  }
  /* @media ${device.laptop} {
    transform: ${({ isPDF }) =>
    isPDF
      ? "scale(0.75) translate(10px, -170px)"
      : "scale(0.8) translate(10px, -125px)"};
    margin: -170px 0px -70px 0px;
    transform-origin: left top;
    padding-left: 600px;
    margin-bottom: -1000px;

    //margin: -685px -650px -610px -680px;
  } */
`;

const TextWrapper = styled.div`
  position: relative;
  @media ${device.mobileS} {
    top: 10px;
    font-size: 8px;
  }
  @media ${device.tablet} {
    top: 20px;
    font-size: 16px;
  }
`;

const P = styled.p`
  margin-bottom: 0;
`;

const Text = styled.div`
  @media ${device.mobileS} {
    width: 300px;
  }
  @media ${device.tablet} {
    width: 156px;
  }
`;

const Title = styled.div`
  font-weight: 800;
  @media ${device.mobileS} {
    font-size: 10px;
    margin-bottom: 4px;
  }
  @media ${device.tablet} {
    font-size: 1em;
    margin-bottom: 8px;
  }
`;

const Spec = styled(Title)`
  @media ${device.mobileS} {
    width: 90px;
  }
  @media ${device.tablet} {
    width: 100px;
  }
`;
const UpperLine = styled.div`
  height: 0;
  @media ${device.mobileS} {
    width: 97px;
    border-top: solid 1px #161616;
    margin-bottom: 17.3px;
  }
  @media ${device.tablet} {
    //margin-top: 167px;
    width: 200px;
    margin-bottom: 32px;
    border-top: solid 1px #161616;
  }
`;

const BottomLine = styled(UpperLine)`
  margin-bottom: 0px;
  @media ${device.mobileS} {
    margin-top: 20px;
  }
  @media ${device.tablet} {
    margin-top: 32px;
  }
`;

const SideDetails = styled.div`
  @media ${device.mobileS} {
    width: 97px;
  }
  @media ${device.tablet} {
    margin-top: 2px;
    width: 225px;
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: start;
  @media ${device.mobileS} {
    font-size: 10px;
  }
  @media ${device.tablet} {
    font-size: 16px;
  }
`;

const RidesEndDevider = styled.div`
  @media ${device.mobileS} {
    margin-bottom: -70px;
  }
  @media ${device.tablet} {
    margin-bottom: 100px;
  }
`;
